import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "../lib/analytics";

/**
 * Tracks SPA route changes as GA4 pageviews. Mount once near the top of the app.
 */
export default function AnalyticsTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    trackPageview(pathname + (search || ""));
  }, [pathname, search]);
  return null;
}
